export default "__VITE_ASSET__DPX7Y4ke__"